<template>
  <div id="app">
    <table>
      <tbody>
        <tr>
          <td style="width: 500px; vertical-align: top;">
            <p>
              <b style="font-size:300%; color:#FFFFF0; vertical-align: top;">Horizontal ocular deviation assessment</b>
            </p>
          </td>
          <td ref="cellphotoheader" style="width: 800px;">
            <img src="./assets/imghaut.png" style="margin-right: auto; margin-left: auto; margin-top: 20px;">
            <p
              style="color:#FFFFF0; max-width: 500px; text-align: justify; margin-block: 5px 5px; margin-right: auto; margin-left: auto"
            >Pictures taken with a flash set above the lens, from a distance of about 1 metre, zoomed on the face from one ear to the other, centered on the nose bottom, clear reflection(s) of the cornea(s).</p>
          </td>
        </tr>
      </tbody>
    </table>

    <table>
      <tbody>
        <tr>
          <td style="width: 400px;">
            <table style=" text-align: center;">
              <tbody>
                <tr>
                  <td style="font-size:150%; width: 25%; color: #FFFFF0;">1-RE</td>
                  <td style="font-size:150%; width: 25%; color: #FFFFF0;">2-LE</td>
                  <td style="font-size:150%; width: 50%; color: #FFFFF0;" colspan="2">3-Binocular</td>
                </tr>
                <tr>
                  <td style="width: 25%;">
                    <div ref="revid" class="textCircle" style="display: inline-block;"></div>
                  </td>
                  <td style="width: 25%;">
                    <div ref="levid" class="textCircle" style="display: inline-block;"></div>
                  </td>
                  <td style="width: 50%;" colspan="2">
                    <div ref="bivid" class="textCircle" style="display: inline-block;"></div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 25%;">
                    <svg height="60" width="5">
                      <line
                        stroke-dasharray="4"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="60"
                        style="stroke:rgb(102,102,102);stroke-width:4"
                      ></line>
                    </svg>
                  </td>
                  <td style="width: 25%;">
                    <svg height="60" width="5">
                      <line
                        stroke-dasharray="4"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="60"
                        style="stroke:rgb(102,102,102);stroke-width:4"
                      ></line>
                    </svg>
                  </td>
                  <td style="width: 50%;" colspan="2">
                    <svg height="60" width="90">
                      <line
                        stroke-dasharray="4"
                        x1="45"
                        y1="0"
                        x2="90"
                        y2="60"
                        style="stroke:rgb(102,102,102);stroke-width:2"
                      ></line>
                      <line
                        stroke-dasharray="4"
                        x1="45"
                        y1="0"
                        x2="0"
                        y2="60"
                        style="stroke:rgb(102,102,102);stroke-width:2"
                      ></line>
                    </svg>
                  </td>
                </tr>
                <tr>
                  <td style="width: 25%;">
                    <div ref="retl" class="textCircle" style="display: inline-block;">TL</div>
                    <p class="txtsouscercle">Temporal limbus</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="lenl" class="textCircle" style="display: inline-block;">NL</div>
                    <p class="txtsouscercle">Nasal limbus</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="bitla" class="textCircle" style="display: inline-block;">TL</div>
                    <p class="txtsouscercle">Temporal limbus</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="binlb" class="textCircle" style="display: inline-block;">NL</div>
                    <p class="txtsouscercle">Nasal limbus</p>
                  </td>
                </tr>
                <tr>
                  <td style="width: 25%;">
                    <div ref="recr" class="textCircle" style="display: inline-block;">CR</div>
                    <p class="txtsouscercle">Corneal reflect</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="lecr" class="textCircle" style="display: inline-block;">CR</div>
                    <p class="txtsouscercle">Corneal reflect</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="bicra" class="textCircle" style="display: inline-block;">CR</div>
                    <p class="txtsouscercle">Corneal reflect</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="bicrb" class="textCircle" style="display: inline-block;">CR</div>
                    <p class="txtsouscercle">Corneal reflect</p>
                  </td>
                </tr>
                <tr>
                  <td style="width: 25%;">
                    <div ref="renl" class="textCircle" style="display: inline-block;">NL</div>
                    <p class="txtsouscercle">Nasal limbus</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="letl" class="textCircle" style="display: inline-block;">TL</div>
                    <p class="txtsouscercle">Temporal limbus</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="binla" class="textCircle" style="display: inline-block;">NL</div>
                    <p class="txtsouscercle">Nasal limbus</p>
                  </td>
                  <td style="width: 25%;">
                    <div ref="bitlb" class="textCircle" style="display: inline-block;">TL</div>
                    <p class="txtsouscercle">Temporal limbus</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td ref="cellcanv" style>
            <div ref="uploadetcropdiv" style="position: absolute; left: 0px; z-index:0; display: none; ">
              <my-upload
                ref="uploadetcrop"
                field="img"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                @cancel="reset"
                v-model="show"
                url
                :params="params"
                :headers="headers"
                :noCircle="true"
                :noSquare="true"
                langType="en"
                img-format="png"
              ></my-upload>
              <!-- <img :src="imgDataUrl"> -->
            </div>
            <div ref="divcanvas" style="cursor: crosshair; display: none; " >
              <canvas
                id="canvas"
                ref="canvpospoint"
                width="500"
                height="500"
                @mousemove="movecanv"
                @mousedown="clickcanv"
              ></canvas>
              <table
                ref="tabresult"
                style="margin-right: auto; margin-left: auto; display: none; color: #FFFFF0;"
              >
                <tbody>
                  <tr>
                    <td>
                      <img ref="resimgre" :src="imgrefull" style="height: 250px">
                    </td>
                    <td>
                      <img ref="resimgle" :src="imglefull" style="height: 250px">
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <img ref="resimgbi" :src="imgbifull" style="height: 250px">
                    </td>
                  </tr>
                  <tr>
                    <td>RE ratio = {{results.reratio}} - RE deviation = {{results.deviaRE}}°</td>
                    <td>LE ratio = {{results.leratio}} - LE deviation = {{results.deviaLE}}°</td>
                  </tr>
                  <tr>
                    <!-- <td>Fixating Eye = {{results.fixatingeye}}</td> -->
                    <td colspan="2">Global deviation = {{results.deviation}}°</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div ref="divStart">
              <table>
<tbody style="color: #FFFFF0;">
<tr>
<td style="font-size:300%; padding: 40px">Required pictures</td>
</tr>
<tr>
<td style="font-size:150%; color: #f0b400; padding: 10px">1 - Monocular: right eye</td>
</tr>
<tr>
<td style="font-size:150%; color: #f0b400; padding: 10px">2 - Monocular: left eye</td>
</tr>
<tr>
<td style="font-size:150%; color: #f0b400; padding: 10px">3 - Binocular</td>
</tr>
<tr>
<td style="padding: 40px">Privacy policy: No personal patient data are stored or collected by this software. Responsability : This code is provided *as is* without warranty of any kind, either express or implied, including any implied warranties of fitness for a particular purpose, merchantability, or non-infringement.</td>
</tr>
</tbody>
</table>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="width:100%;">
            <table>
              <tbody>
                <tr>
                  <td valign="top" style="width: 140px; ">
                    <button ref="boutonreset" class="myButton" @click="reset">Reset all</button>
                    </td>
                  <td  valign="top">
                    <button ref="boutonetape" class="myButton" style="width: 224px; margin-right: 10px" @click="toggleShow">Import right-eye picture</button>
                    </td>
                  <button
              ref="boutonpdf"
              class="myButton"
              style="float: right; margin-top: 25px; margin-left: 25px; display: none"
              @click="genererpdf"
            >Download PDF</button>
                  <td ref="consignestd" valign="top" bgcolor="#3276ed" style="border-radius: 10px; visibility: collapse;"><p
                      ref="consignes"
                      style="float: left; margin-left: 10px; margin-right: 10px; color:#FFFFF0; visibility: collapse;"
                    >Import right eye monocular picture to start.</p></td>
                  </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <table style="width:100%;">
<tbody>
<tr>
<td style="float: left; color:#FFFFF0;">Department of Ophthalmology, University Hospital of Nantes, Nantes, France</td>
<td>  </td>
<td style="float: right; color:#FFFFF0;"> Powered by FNRO, Sponsored by FNRO, AFSOP, SFO, INSERM and LISSAC OPTIC 2000 </td>
</tr>
</tbody>
</table>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

//import 'babel-polyfill'; // es6 shim
import Vue from "vue";
import myUpload from "./components/upload-2.vue";
import jsPDF from "jspdf";
import axios from "axios";

export default {
  name: "app",
  data: function() {
    return {
      repasync: 0,
      show: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      imgDataUrl: "", // the datebase64 url of created image
      canvpospt: [],
      ptre: [],
      ptle: [],
      ptbinore: [],
      ptbinole: [],
      etape: 1,
      window: {
        width: 0,
        height: 0
      },
      imgre: "",
      imgle: "",
      imgbire: "",
      imgbile: "",
      imgrefull: "",
      imglefull: "",
      imgbifull: "",
      results: {
        reratio: 0,
        leratio: 0,
        fixatingeye: "le",
        deviation: "20°",
        deviaRE: 0,
        deviaLE: 0
      },
      forcerMonoOD: 0,
      forcerMonoOG: 0,
      timer: "",
      idxtimer: 0
    };
  },

  components: {
    HelloWorld,
    "my-upload": myUpload
  },

  created() {
    document.addEventListener("keyup", e => {
      if (e.key == "Enter" || e.keyCode == 13) {
        if (
          this.etape == 1 ||
          this.etape == 8 ||
          this.etape == 14 ||
          this.etape == 20
        )
        {
          return;
        }
        this.toggleShow();
      }
    }),
      window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.handleResize();
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    handleResize() {
      this.window.height = window.innerHeight;
      this.window.width = window.innerWidth;
      var hauteur = this.window.height - 385;
      var largeur = this.window.width - 402;
      // Les images doivent être au format 4/3
      if (largeur / hauteur > 1.33) largeur = 1.33 * hauteur;
      else hauteur = 0.75 * largeur;

      this.$refs.canvpospoint.width = largeur;
      this.$refs.canvpospoint.height = hauteur;
      this.$refs.uploadetcrop.width = largeur;
      this.$refs.uploadetcrop.height = hauteur;
      this.$refs.cellphotoheader.width = largeur;
      this.$refs.consignes.style.maxWidth = (largeur - 25) + "px";

      this.$refs.canvpospoint.dispatchEvent(new Event("mousemove"));
    },
    toggleShow() {
      switch (this.etape) {
        case 1:
          if (this.show)
            return;
          this.$refs.divStart.style.display = "none";
          this.$refs.uploadetcropdiv.style.display = "block";
          this.$refs.divcanvas.style.display = "block";
          this.$refs.consignes.style.visibility = "";
          this.$refs.consignestd.style.visibility = "";
          this.imgDataUrl = "";
          this.$refs.uploadetcrop.etapedebut = 1;
          this.$refs.consignes.innerHTML =
            "Adjust size of the picture by magnifier or use '+' and '-' keys in order to place the cornea approximatively in the red circle. To change position press left click and drag. Proceed with 'Continue' or use 'ENTER' key.";
          this.show = !this.show;
          break;
        case 7:
          if (this.show)
            return;
          this.imgDataUrl = "";
          this.$refs.uploadetcrop.etapedebut = 1;
          this.$refs.consignes.innerHTML =
            "Adjust size of the picture by magnifier or use '+' and '-' keys in order to place the cornea approximatively in the red circle. To change position press left click and drag. Proceed with 'Continue' or use 'ENTER' key.";
          this.show = !this.show;
          break;
        case 13:
          if (this.show)
            return;
          this.imgDataUrl = "";
          this.$refs.uploadetcrop.etapedebut = 1;
          this.$refs.consignes.innerHTML =
            "Right eye: Adjust size of the picture by magnifier or use '+' and '-' keys in order to place the cornea approximatively in the red circle. To change position press left click and drag. Proceed with 'Continue' or use 'ENTER' key.";
          this.show = !this.show;
          break;
        case 3:
          this.etape += 1;
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.innerHTML =
            "Mark the center of the corneal reflect. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
          break;
        case 5:
          this.etape += 1;
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.innerHTML =
            "Mark the most internal point of the nasal limbus. To change the position press left click again. Proceed with 'Import left-eye picture' or use 'ENTER' key.";
          break;
        case 9:
          this.etape += 1;
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.innerHTML =
            "Mark the center of the corneal reflect. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
          break;
        case 11:
          this.etape += 1;
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.innerHTML =
            "Mark the the most external point of the temporal limbus. To change the position press left click again. Proceed with 'Import binocular picture' or use 'ENTER' key.";
          break;
        case 15:
          this.etape += 1;
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.innerHTML =
            "Mark the center of the corneal reflect. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
          break;
        case 17:
          this.etape += 1;
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.innerHTML =
            "Mark the most internal point of the nasal limbus. To change the position press left click again. Proceed with 'Next eye' or use 'ENTER' key.";
          break;
        case 21:
          this.etape += 1;
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.innerHTML =
            "Mark the center of the corneal reflect. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
          break;
        case 23:
          this.etape += 1;
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.innerHTML =
            "Mark the the most external point of the temporal limbus. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
          break;
        case 19:
          this.$refs.consignes.innerHTML =
            "Left eye: Adjust size of the picture by magnifier or use '+' and '-' keys in order to place the cornea approximatively in the red circle. To change position press left click and drag. Proceed with 'Continue' or use 'ENTER' key.";
          this.$refs.uploadetcrop.etapedebut = 2;
          this.$refs.uploadetcrop.scale.range = 1;
          this.$refs.uploadetcrop.startCrop();
          this.show = !this.show;
          break;
        case 25:
          this.$refs.boutonetape.style.visibility = "hidden";
          this.$refs.consignes.style.visibility = "hidden";
          this.$refs.consignestd.style.visibility = "hidden";
          this.$refs.uploadetcropdiv.style.display = "none";
          this.$refs.canvpospoint.style.display = "none";
          this.$refs.tabresult.style.display = "block";
          this.$refs.boutonpdf.style.display = "block";
          this.calculResult();
          break;
      }
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field, imgFullUrl) { 
      this.imgDataUrl = imgDataUrl;
      this.canvpospt = [];
      if (this.etape == 1) {
        this.$refs.revid.style.backgroundColor = "rgb(0, 128, 255)";
        this.imgre = imgDataUrl;
        this.imgrefull = imgFullUrl;
        this.$refs.consignes.innerHTML =
          "Mark the the most external point of the temporal limbus. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
      }
      if (this.etape == 7) {
        this.$refs.levid.style.backgroundColor = "rgb(0, 128, 255)";
        this.imgle = imgDataUrl;
        this.imglefull = imgFullUrl;
        this.$refs.consignes.innerHTML =
          "Mark the the most internal point of the nasal limbus. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
      }
      if (this.etape == 13) {
        this.$refs.bivid.style.backgroundColor = "rgb(0, 128, 255)";
        this.imgbire = imgDataUrl;
        this.imgbifull = imgFullUrl;
        this.$refs.consignes.innerHTML =
          "Mark the the most most external point of the external limbus. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
      }
      if (this.etape == 19) {
        this.$refs.bivid.style.backgroundColor = "rgb(0, 128, 255)";
        this.imgbile = imgDataUrl;
        this.imgbifull = imgFullUrl;
        this.$refs.consignes.innerHTML =
          "Mark the the most internal point of the nasal limbus. To change the position press left click again. Proceed with 'Continue' or use 'ENTER' key.";
      }

      this.etape += 1;
      this.$refs.boutonetape.style.visibility = "hidden";

      this.timer = setInterval(this.updatecanvastimer, 100);
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },

    movecanv(event) {
      if (this.etape == 1 || this.etape > 24) return;

      if (event === null) {
        x = 800;
        y = 578;
      } else {
        var y = event.clientY;
        var x = event.clientX;
      }

      if (x === undefined) x = 800;
      if (y === undefined) y = 578;

      var ycanv = canvas.height;
      var xcanv = canvas.width;

      var posxrel = x - this.$refs.divcanvas.getBoundingClientRect().left;
      var posyrel = y - this.$refs.divcanvas.getBoundingClientRect().top;

      var context = this.$refs.canvpospoint.getContext("2d");
      context.clearRect(0, 0, xcanv, ycanv);
      context.strokeStyle = "rgba(255, 0, 0, 255)";

      var img = new Image();
      img.src = this.imgDataUrl;
      context.drawImage(img, 0, 0);

      // Reset the current path
      context.beginPath();
      // Staring point (10,45)
      context.moveTo(posxrel, 0);
      // End point (180,47)
      context.lineTo(posxrel, ycanv);
      // Make the line visible
      context.stroke();
      //  Reset the current path
      context.beginPath();
      // Staring point (10,45)
      context.moveTo(0, posyrel);
      // End point (180,47)
      context.lineTo(xcanv, posyrel);
      // Make the line visible
      context.stroke();

      this.canvpospt.forEach(function(item, index, array) {
        // Reset the current path
        context.beginPath();
        // Staring point (10,45)
        context.arc(item.x, item.y, 3, 0, 2 * Math.PI);
        // Make the line visible
        context.stroke();
      });
    },

    async clickcanv(event) {
      if (this.etape == 1 || this.etape > 24) return;

      if (
        this.etape == 3 ||
        this.etape == 5 ||
        this.etape == 7 ||
        this.etape == 9 ||
        this.etape == 11 ||
        this.etape == 13 ||
        this.etape == 15 ||
        this.etape == 17 ||
        this.etape == 19 ||
        this.etape == 21 ||
        this.etape == 25 ||
        this.etape == 23
      ) {
        this.etape -= 1;
        this.canvpospt.pop();
      }

      var y = event.clientY;
      var x = event.clientX;
      var ycanv = canvas.height;
      var xcanv = canvas.width;

      var posxrel = x - this.$refs.divcanvas.getBoundingClientRect().left;
      var posyrel = y - this.$refs.divcanvas.getBoundingClientRect().top;

      this.canvpospt.push({ x: posxrel, y: posyrel });
      var context = this.$refs.canvpospoint.getContext("2d");
      context.strokeStyle = "rgba(255, 0, 0, 255)";

      this.canvpospt.forEach(function(item, index, array) {
        // Reset the current path
        context.beginPath();
        // Staring point (10,45)
        context.arc(item.x, item.y, 3, 0, 2 * Math.PI);
        // Make the line visible
        context.stroke();
      });

      switch (this.etape) {
        case 2:
          this.etape += 1;
          this.$refs.retl.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Continue";
          break;
        case 4:
          this.etape += 1;
          this.$refs.recr.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Continue";
          break;
        case 6:
          var resultverif = await this.verifRatioMono();
          if (!resultverif)
              this.forcerMonoOD = 1;
          // if (!resultverif)
          // {
          //    this.etape = 2;
          //    this.canvpospt = [];
          //    this.$refs.retl.style.backgroundColor = 'transparent';
          //    this.$refs.recr.style.backgroundColor = 'transparent';
          //    this.movecanv(null);
          //    return;
          // }
          this.etape += 1;
          this.$refs.renl.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Import left-eye picture";
          this.ptre = this.canvpospt.map(a => Object.assign({}, a));
          break;
        case 8:
          this.etape += 1;
          this.$refs.lenl.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Continue";
          break;
        case 10:
          this.etape += 1;
          this.$refs.lecr.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Continue";
          break;
        case 12:
          var resultverif = await this.verifRatioMono();
          if (!resultverif)
              this.forcerMonoOG = 1;
          // if (!resultverif)
          // {
          //    this.etape = 8;
          //    this.canvpospt = [];
          //    this.$refs.lenl.style.backgroundColor = 'transparent';
          //    this.$refs.lecr.style.backgroundColor = 'transparent';
          //    this.movecanv(null);
          //    return;
          // }
          this.etape += 1;
          this.$refs.letl.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Import binocular picture";
          this.ptle = this.canvpospt.map(a => Object.assign({}, a));
          break;
        case 14:
          this.etape += 1;
          this.$refs.bitla.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Continue";
          break;
        case 16:
          this.etape += 1;
          this.$refs.bicra.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Continue";
          break;
        case 18:
          this.etape += 1;
          this.$refs.binla.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Next eye";
          this.ptbinore = this.canvpospt.map(a => Object.assign({}, a));
          break;
        case 20:
          this.etape += 1;
          this.$refs.binlb.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Continue";
          break;
        case 22:
          this.etape += 1;
          this.$refs.bicrb.style.backgroundColor = "rgb(0, 128, 255)";
          this.$refs.boutonetape.style.visibility = "visible";
          this.$refs.boutonetape.innerText = "Continue";
          break;
        case 24:
          var resultverif = await this.verifDeviaBinoFixe();
          if (!resultverif)
          {
             this.etape = 14;
             this.canvpospt = [];
             this.ptbinore = [];
             this.imgDataUrl = this.imgbire;
             this.$refs.bitla.style.backgroundColor = 'transparent';
             this.$refs.bicra.style.backgroundColor = 'transparent';
             this.$refs.binla.style.backgroundColor = 'transparent';
             this.$refs.binlb.style.backgroundColor = 'transparent';
             this.$refs.bicrb.style.backgroundColor = 'transparent';
             this.movecanv(null);
             return;
          }
          this.etape += 1;
          this.$refs.bitlb.style.backgroundColor = "rgb(0, 128, 255)";
          this.ptbinole = this.canvpospt.map(a => Object.assign({}, a));
          this.toggleShow();
          break;
      }
    },
    async genererpdf() {
// var specialElementHandlers = {
//   // element with id of "bypass" - jQuery style selector
//   '.no-export': function(element, renderer) {
//     // true = "handled elsewhere, bypass text extraction"
//     return true;
//   }
// };

//       var doc = new jsPDF('p', 'pt', 'a4');
//       var source = this.$refs.tabresult.innerHTML;
//       var margins = {top: 10, bottom: 10, left: 10, width: 595};
//       doc.fromHTML(
//     source, // HTML string or DOM elem ref.
//     margins.left,
//     margins.top, {
//       'width': margins.width,
//       'elementHandlers': specialElementHandlers
//     },

//     function(dispose) {
//       // dispose: object with X, Y of the last line add to the PDF 
//       //          this allow the insertion of new lines after html
//       doc.save('straboCheck.pdf');
//     }, margins);

var dimRE = await this.getImageDimensions(this.imgrefull);
var dimLE = await this.getImageDimensions(this.imglefull);
var dimBI = await this.getImageDimensions(this.imgbifull);
dimRE = this.ratioImage(dimRE);
dimLE = this.ratioImage(dimLE);
dimBI = this.ratioImage(dimBI);

      var doc = new jsPDF();
      doc.setFontSize(40);
      doc.text("Horizontal ocular", 51, 25);
    doc.text("deviation assessment", 35, 40);
    doc.addImage(this.imgrefull, "JPEG", 17, 60, dimRE.w, dimRE.h);
    doc.addImage(this.imglefull, "JPEG", 110, 60, dimLE.w, dimLE.h);
    doc.addImage(this.imgbifull, "JPEG", 63, 130, dimLE.w, dimLE.h);
    doc.setFontSize(17);
      doc.text("RE Ratio = " + this.results.reratio, 30, 215);
      doc.text("LE Ratio = " + this.results.leratio, 105, 215);
  //    doc.text("Fixating eye = " + this.results.fixatingeye, 35, 235);
      doc.text("RE deviation = " + this.results.deviaRE + "°", 30, 225);
      doc.text("LE deviation = " + this.results.deviaLE + "°", 105, 225);
      doc.text("Global deviation = " + this.results.deviation + "°", 65, 235);

      doc.setFontSize(10);
doc.setFontType("bold");
doc.text("STRABOCHECK.COM", 85, 250);
doc.setFontType("normal");
doc.setFontSize(8);
doc.text("Version 16/08/2019 - contact@strabocheck.com", 73, 255);
doc.text("This result is provided *as is* without warranty of any kind, either express or implied, including any implied warranties of fitness for a particular purpose", 10, 262);
doc.text("any implied warranties of fitness for a particular purpose, merchantability, or non-infringement.", 45, 265);
doc.text("Department of Ophthalmology, University Hospital of Nantes, Nantes, France", 13, 275);
doc.text("Powered by FNRO, Sponsored by FNRO, AFSOP, SFO, INSERM and LISSAC OPTIC 2000", 10, 279);

var imgLogo64 = 'data:image/png;base64,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';

doc.addImage(imgLogo64, "JPEG", 120, 272, 69, 9);

      doc.save("straboCheck.pdf");
    },
    reset() {
      document.location.reload();
    },
    async calculResult() {
    let resultfinal = await this.httpGetSync("api/calculresult.php?" +  this.ptre[0].x + "_" +  this.ptre[1].x + "_" + +  this.ptre[2].x + "_" +  this.ptle[0].x + "_" +  this.ptle[1].x + "_" + +  this.ptle[2].x + "_" +  this.ptbinore[0].x + "_" +  this.ptbinore[1].x + "_" + +  this.ptbinore[2].x + "_" +  this.ptbinole[0].x + "_" +  this.ptbinole[1].x + "_" + +  this.ptbinole[2].x + "_" + this.forcerMonoOD + "_" + this.forcerMonoOG);

    var restab = this.repasync.split(';');

    this.results.reratio = restab[0];
    this.results.leratio = restab[1];
    this.results.fixatingeye = restab[2];
    this.results.deviation = restab[3];
    this.results.deviaRE = restab[4];
    this.results.deviaLE = restab[5];
    },

    getImageDimensions(file) {
  return new Promise (function (resolved, rejected) {
    var i = new Image()
    i.onload = function(){
      resolved({w: i.width, h: i.height})
    };

    i.src = file
  })
},

ratioImage(dim)
  {
    var ratioH = dim.h / 66;
    var ratioL = dim.w / 88;

    var newDim = {w: dim.w / Math.max(ratioH, ratioL), h: dim.h / Math.max(ratioH, ratioL)};
    return newDim;
  },

    async verifRatioMono()
    {
      var ratioMono = 15
      if (this.etape < 7)
      {
        let ratioMono = await this.httpGetSync("api/calculmonodroit.php?" +  this.canvpospt[0].x + "_" +  this.canvpospt[1].x + "_" + +  this.canvpospt[2].x );
      }
      else
      {
        let ratioMono = await this.httpGetSync("api/calculmonogauche.php?" +  this.canvpospt[0].x + "_" +  this.canvpospt[1].x + "_" + +  this.canvpospt[2].x );
      }

     // console.log("Ratio mono : " + this.repasync);
      if (this.repasync == 0)
      {
        if(confirm('Out-of-range Kappa angle value: do you want to take the other eye ratio (Ok) or keep this one (Cancel) ?'))
        {
          return true;
        }
        else
        {
          return false;
        }
      }
      return true;
    },

    async verifDeviaBinoFixe()
    {
      let deviationbino = await this.httpGetSync("api/calculbino.php?" +  this.ptre[0].x + "_" +  this.ptre[1].x + "_" + +  this.ptre[2].x + "_"  +  this.ptle[0].x + "_" +  this.ptle[1].x + "_" + +  this.ptle[2].x + "_"  +  this.ptbinore[0].x + "_" +  this.ptbinore[1].x + "_" + +  this.ptbinore[2].x + "_"  +  this.canvpospt[0].x + "_" +  this.canvpospt[1].x + "_" + +  this.canvpospt[2].x);

      if (this.repasync == 0)
      {
        if(confirm('Bad fixation: do you confirm the measurement ?'))
        {
          return true;
        }
        else
        {
          return false;
        }
      }
      return true;
    },

    httpGet(theUrl)
    {
    // var xmlHttp = new XMLHttpRequest();
    // xmlHttp.open( "GET", theUrl, false ); // false for synchronous request
    // xmlHttp.send( null );
    // return xmlHttp.responseText;

    return axios.get(theUrl);
    //.then((response) => {return response.data})
    },

    async httpGetSync(theUrl)
    {
      let response = await axios.get(theUrl);
  //    console.log("test async full " + response);
      this.repasync = response.data;
  //    console.log("test async data " + this.testasync);

      return this.repasync;


      // let resu = await this.httpGet(theUrl);
      // return resu.data;


    //  return this.httpGet(theUrl).then((data) => {return data})
    },

    updatecanvastimer() {
      this.movecanv(null);
      this.idxtimer++;
      if (this.idxtimer > 2) {
        this.cancelAutoUpdate();
        this.idxtimer = 0;
      }
    },

    cancelAutoUpdate() {
      clearInterval(this.timer);
    }
  }
};
</script>
<style lang="stylus">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666;
  background: rgb(9, 20, 56);
  padding-top: 3px;
  padding-left: 15px;
}
</style>

<style>
.textCircle {
  width: 60px;
  height: 1px;
  border-radius: 50%;
  border: 2px solid #fffff0;
  text-align: center;
  font-size: 20px;
  padding: 30px 0;
  line-height: 0;
  position: relative;
  color: #fffff0;
  font-family: Helvetica, Arial Black, sans;
}
.txtsouscercle {
  color: #fffff0;
  text-align: center;
  font: 12px Arial, sans-serif;
  margin: 0px;
  max-width: 45px;
  display: inline-block;
}

.myButton {
  -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
  -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
  box-shadow: inset 0px 1px 0px 0px #ffffff;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0.05, #ededed),
    color-stop(1, #dfdfdf)
  );
  background: -moz-linear-gradient(top, #ededed 5%, #dfdfdf 100%);
  background: -webkit-linear-gradient(top, #ededed 5%, #dfdfdf 100%);
  background: -o-linear-gradient(top, #ededed 5%, #dfdfdf 100%);
  background: -ms-linear-gradient(top, #ededed 5%, #dfdfdf 100%);
  background: linear-gradient(to bottom, #ededed 5%, #dfdfdf 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ededed', endColorstr='#dfdfdf',GradientType=0);
  background-color: #ededed;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
  border-radius: 6px;
  border: 1px solid #dcdcdc;
  display: inline-block;
  cursor: pointer;
  color: #f0b400;
  font-family: Arial;
  font-size: 15px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
  text-shadow: 0px 1px 0px #ffffff;
}
.myButton:hover {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0.05, #dfdfdf),
    color-stop(1, #ededed)
  );
  background: -moz-linear-gradient(top, #dfdfdf 5%, #ededed 100%);
  background: -webkit-linear-gradient(top, #dfdfdf 5%, #ededed 100%);
  background: -o-linear-gradient(top, #dfdfdf 5%, #ededed 100%);
  background: -ms-linear-gradient(top, #dfdfdf 5%, #ededed 100%);
  background: linear-gradient(to bottom, #dfdfdf 5%, #ededed 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#dfdfdf', endColorstr='#ededed',GradientType=0);
  background-color: #dfdfdf;
}
.myButton:active {
  position: relative;
  top: 1px;
}
</style>